import type { FaireProductEntity } from "../../entity_types/product";

export const p_s9nrbjccsu: FaireProductEntity = {
  token: "p_s9nrbjccsu",
  type: "product",
  name: "Rock & Branch\u00ae Acacia Wood Charcuterie Serving Paddle Board",
  brandName: "Totally Bamboo",
  imageUrl:
    "https://cdn.faire.com/fastly/f242d1410bfded18a3261f6ce71313d5ebdb27c026074c7b69c6b50a719f1734.jpeg",
  priceDollars: 10,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/bba4449887c296f484ea27239b134d0ee9be70acd4511a729e27cd50f0eb1aa0.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
